import { Grid, Typography } from "@mui/material";
import InstituteWiseMaterial from "./InstituteWiseMaterial";
import PendingRackMaterial from "./PendingRackMaterial";
import MaterialStatusWiseMaterial from "./MaterialStatusWiseMaterial";
import RecentlyAddedBooksWidget from "./RecentlyAddedBooksWidget";
import { GetMaterialWidgets } from "features/libraryDashboard/api/hooks";
import { useEffect, useState } from "react";
import { IMaterialResults } from "features/libraryDashboard/api/types";

const MaterialStatistics = () => {
  const { data: result } = GetMaterialWidgets();
  const [material, setMaterial] = useState<IMaterialResults>();

  useEffect(() => {
    if (result?.status === 200) {
      setMaterial(result?.apiData);
    }
  }, [result]);

  return (
    <>
      <Grid>
        <Typography variant="h2">Material</Typography>
      </Grid>

      <Grid container spacing={2.5} sx={{ my: 1 }}>
        <Grid item xs={12} sm={6} lg={4}>
          <InstituteWiseMaterial data={material?.instituteWiseMaterial} />
        </Grid>

        <Grid item xs={12} sm={6} lg={4}>
          <PendingRackMaterial data={material?.materialTypeWiseMaterial} />
        </Grid>
        <Grid item xs={12} sm={6} lg={4}>
          <MaterialStatusWiseMaterial
            data={material?.materialStatusWiseMaterial}
            availableIssued={material?.availableIssuedMaterial}
          />
        </Grid>
      </Grid>

      <RecentlyAddedBooksWidget />
    </>
  );
};
export default MaterialStatistics;
